module.exports = __webpack_public_path__ + "static/media/conflict.04f0e2f3.jpg";